<section class="logo-editor">
  <article *ngIf="view==VIEW_MAIN" class="logo-main">
    <span class="modal-close" (click)="cancel()" title="Close">✕</span>
    <header class="logo-editor-header">
      <core-title-section
      [title]="'Organization Logo'"
      [description]="''"
      ></core-title-section>
    </header>
    <div class="logo-editor-cropper">
      <figure>
          <organization-profile-logo-img *ngIf="!working; else logoWorking" [organization]="org" [width]="300"></organization-profile-logo-img>
          <ng-template #logoWorking> <core-helpers-box-loading [hidden]="loaded"></core-helpers-box-loading> </ng-template>
      </figure>
    </div>
    <fieldset>
      <div>
        <core-helpers-forms-button-white [text]="'Edit'" [disabled]="file==null" (click)= "show(VIEW_EDIT)"></core-helpers-forms-button-white>
        <core-helpers-forms-button-white [text]="'Add logo'" (click)="show(VIEW_UPLOAD)"></core-helpers-forms-button-white>
      </div>
      <core-helpers-forms-button-white [text]="'Delete'" [disabled]="file==null" (click)="delete()"></core-helpers-forms-button-white>
    </fieldset>
  </article>

    <organization-profile-logo-upload *ngIf="view==VIEW_UPLOAD" (uploaded)="uploadFile($event)" (cancel)="cancelOption()"></organization-profile-logo-upload>
    <organization-profile-logo-edit *ngIf="view==VIEW_EDIT" (cancel)="cancelOption()" (save)="saveOption($event)" [file]="file" [options]="options"></organization-profile-logo-edit>
</section>
